import axios from 'axios';
import { API_BASE_URL } from '@/apiConfig';

const apiClient = axios.create({
	baseURL: API_BASE_URL,
	timeout: 20000,
	headers: {
		Accept: 'application/json',
	},
});

apiClient.interceptors.request.use((config) => {
	const rawToken = localStorage.getItem('token');
	let token = rawToken;

	if (rawToken && rawToken.startsWith('"') && rawToken.endsWith('"')) {
		try {
			token = JSON.parse(rawToken);
		} catch (error) {
			token = rawToken;
		}
	}

	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}

	const csrfToken = document
		.querySelector('meta[name="csrf-token"]')
		?.getAttribute('content');

	if (csrfToken) {
		config.headers['X-CSRF-TOKEN'] = csrfToken;
	}

	return config;
});

export default apiClient;